export default __webpack_public_path__ + "static/media/haircut.65cc2434.png";